/**
 * Adobe Target activity identifiers used by the registration app.
 *
 * Register an activity here so local dev simulation (src/dev.activities.js) and
 * production reads reference the same activity name. The activity itself is
 * created in the Adobe Target console separately.
 *
 * For more information see:
 *   https://www.familysearch.org/frontier/docs/develop/adobe-target
 */
export default {
  // Marketing opt-in A/B experiment (IDENTITY-3859).
  //   IdentityIdpMessageOptInControl      -> show the email opt-in checkbox during registration
  //   IdentityIdpMessageOptInInterjection -> hide the checkbox; prompt via a post-login interjection
  // Experience names follow the [Team][Page][Variant] convention and must match the
  // Adobe Target UI and JSON experienceId exactly.
  MESSAGE_OPT_IN: {
    name: 'identity_registration_idpMessageOptIn',
    experience: {
      CONTROL: 'IdentityIdpMessageOptInControl',
      INTERJECTION: 'IdentityIdpMessageOptInInterjection',
    },
  },
}
